export default "__VITE_ASSET__1dda172a__"